<div class="earn">

  <!-- ============ PAGE HEAD ============ -->
  <div class="pagehead">
    <div>
      <h1>Earnings</h1>
      <p>Commission, TDS and volume by service · {{ periodCaption }}</p>
    </div>
    <div class="filters">
      <div class="seg" role="tablist" aria-label="Period">
        <button type="button" [class.on]="period === 'Today'" (click)="setPeriod('Today')">Today</button>
        <button type="button" [class.on]="period === 'Last 7 Days'" (click)="setPeriod('Last 7 Days')">7 days</button>
        <button type="button" [class.on]="period === 'Current Month'" (click)="setPeriod('Current Month')">This month</button>
      </div>
      <button type="button" class="btn" (click)="goToExcel()">
        <svg viewBox="0 0 24 24"><path d="M12 3v12M7 11l5 4 5-4M4 21h16"/></svg>Export
      </button>
    </div>
  </div>

  <!-- ============ KPI ROW ============ -->
  <div class="kpis">
    <ng-container *ngIf="commissionCount; else kpiSkel">
      <div class="card kpi">
        <div class="clabel"><svg viewBox="0 0 24 24"><path d="M3 12h18M12 3v18"/></svg>Total volume</div>
        <div class="num">{{ periodGtv | erInr:'paise' }}</div>
        <div class="foot"><span class="vs">Gross transaction value</span></div>
      </div>
      <div class="card kpi">
        <div class="clabel"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>Commission before TDS</div>
        <div class="num">{{ totalBcomm | erInr:'paise' }}</div>
        <div class="foot"><span class="vs">Earned across all services</span></div>
      </div>
      <div class="card kpi">
        <div class="clabel"><svg viewBox="0 0 24 24"><path d="M6 3h9l3 3v15H6z"/><path d="M9 12h6M9 16h6"/></svg>TDS deducted</div>
        <div class="num">{{ totalTds | erInr:'paise' }}</div>
        <div class="foot"><span class="vs">Withheld this period</span></div>
      </div>
      <div class="card kpi">
        <div class="clabel"><svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>Net commission</div>
        <div class="num num--green">{{ totalcomm | erInr:'paise' }}</div>
        <div class="foot"><span class="vs">After TDS — yours to keep</span></div>
      </div>
    </ng-container>
    <ng-template #kpiSkel>
      <div class="card kpi" *ngFor="let i of [1,2,3,4]">
        <div class="er-skel er-skel--text label-skel"></div>
        <div class="er-skel er-skel--title num-skel"></div>
        <div class="er-skel er-skel--text foot-skel"></div>
      </div>
    </ng-template>
  </div>

  <!-- ============ SERVICE BREAKDOWN TABLE ============ -->
  <div class="tbl-card">
    <div class="tbl-head">
      <h3>Service breakdown</h3>
      <a (click)="goToExcel()">Download excel →</a>
    </div>
    <div class="tbl-scroll" *ngIf="commissionCount; else tblSkel">
      <table>
        <thead>
          <tr>
            <th>Service</th>
            <th class="r">GTV</th>
            <th class="r">Commission before TDS</th>
            <th class="r">TDS</th>
            <th class="r">Net commission</th>
            <th class="r">Discount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of serviceRows">
            <td class="svc">{{ s.name }}</td>
            <td class="r"><span class="amt">{{ s.gtv | erInr:'paise' }}</span></td>
            <td class="r">{{ s.before | erInr:'paise' }}</td>
            <td class="r">{{ s.tds | erInr:'paise' }}</td>
            <td class="r"><span class="amt amt--green">{{ s.net | erInr:'paise' }}</span></td>
            <td class="r"><span [class.faint]="s.discount === null">{{ s.discount === null ? '—' : (s.discount | erInr:'paise') }}</span></td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="svc">Total</td>
            <td class="r"><span class="amt">{{ periodGtv | erInr:'paise' }}</span></td>
            <td class="r"><span class="amt">{{ totalBcomm | erInr:'paise' }}</span></td>
            <td class="r"><span class="amt">{{ totalTds | erInr:'paise' }}</span></td>
            <td class="r"><span class="amt amt--green">{{ totalcomm | erInr:'paise' }}</span></td>
            <td class="r"><span class="faint">—</span></td>
          </tr>
        </tfoot>
      </table>
    </div>
    <ng-template #tblSkel>
      <div class="tbl-state">
        <div class="er-skel er-skel--text row-skel" *ngFor="let i of [1,2,3,4,5,6]"></div>
      </div>
    </ng-template>
  </div>

</div>
